/**
 * @generated SignedSource<<429c06d4327983156839ff5935967afb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Bookmarks_stream$data = {
  readonly id: string;
  readonly tabs: ReadonlyArray<{
    readonly icon: string | null;
    readonly id: string;
    readonly isEmbedded: boolean;
    readonly order: number;
    readonly otherStreamId: string | null;
    readonly title: string;
    readonly url: string | null;
  }>;
  readonly " $fragmentType": "Bookmarks_stream";
};
export type Bookmarks_stream$key = {
  readonly " $data"?: Bookmarks_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"Bookmarks_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Bookmarks_stream",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStreamTabNode",
      "kind": "LinkedField",
      "name": "tabs",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "otherStreamId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "order",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEmbedded",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "1ec9368b8e7e2ac3a43abd7d42b6a61e";

export default node;
